'use strict';
Object.defineProperty(exports, '__esModule', { value: true });

exports.slotId = {
    inferredBrandDesktop: {
        slot: 272001103,
        name: 'Inferred Brand - BWS - Desktop' 
    },
    inferredBrandMobile: {
        slot: 272101103,
        name: 'Inferred Brand - BWS - Mobile'
     },
    search: {
        GridDesktop: {
            slot: 272001101,
            name: 'Search In-Grid - BWS - Desktop'
        },
        GridMobile: {
            slot: 272101101,
            name: 'Search In-Grid - BWS - Mobile'
        },
        SlimBannerDesktop: {
            slot: 272001201,
            name: 'Search Slim Banner - BWS - Desktop'
        },
        SlimBannerMobile: {
            slot: 272101201,
            name: 'Search Slim Banner - BWS - Mobile'
        },
        HeroBannerDesktop: {
            slot: 272001202,
            name: 'Search Hero Banner - BWS - Desktop'
        },
        HeroBannerMobile: {
            slot: 272001202,
            name: 'Search Hero Banner - BWS - Mobile'
        },
        FeatureTileDesktop: {
            slot: 272004201,
            name: 'Search Feature Tile - BWS - Desktop'
        },
        FeatureTileMobile: {
            slot: 272104201,
            name: 'Search Feature Tile - BWS - Mobile'
        }
    },
    browse: {
        GridDesktop: {
            slot: 272002101,
            name: 'Browse In-Grid - BWS - Desktop'
        },
        GridMobile: {
            slot: 272102101,
            name: 'Browse In-Grid - BWS - Mobile'
        },
        SlimBannerDesktop: {
            slot: 272002201,
            name: 'Browse Slim Banner - BWS - Desktop'
        },
        SlimBannerMobile: {
            slot: 272102201,
            name: 'Browse Slim Banner - BWS - Mobile'
        },
        HeroBannerDesktop: {
            slot: 271002203,
            name: 'Browse Hero Banner - BWS - Desktop'
        },
        HeroBannerMobile: {
            slot: 271102203,
            name: 'Browse Hero Banner - BWS - Mobile'
        },
        FeatureTileDesktop: {
            slot: 272003201,
            name: 'Browse Feature Tile - BWS - Desktop'
        },
        FeatureTileMobile: {
            slot: 272103201,
            name: 'Browse Feature Tile - BWS - Mobile'
        }
    }
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/slotId.js
 **/